import { useQuery, useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ApiError from '../utils/ApiError';

async function updateNewsItem(values) {
  const response = await fetch(`/api/news/${values.id}`, {
    method: 'PUT',
    body: JSON.stringify(values),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export function useUpdateNewsItem() {
  const queryClient = useQueryClient();
  return useMutation(updateNewsItem, {
    onError: (error) =>
      toast(error.message ?? 'Failed to update news item.', {
        type: 'error',
      }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries('news-feed');
      toast('News item updated successfully', {
        type: 'success',
      });
    },
  });
}

async function createNewsItem(values) {
  const response = await fetch(`/api/news`, {
    method: 'POST',
    body: JSON.stringify(values),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export function useCreateNewsItem() {
  const queryClient = useQueryClient();
  return useMutation(createNewsItem, {
    onError: (error) =>
      toast(error.message ?? 'Failed to create news item.', {
        type: 'error',
      }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries('news-feed');
      toast('News item created successfully', {
        type: 'success',
      });
    },
  });
}

async function deleteItem(id) {
  const response = await fetch(`/api/news/${id}`, {
    method: 'DELETE',
  });
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export function useDeleteNewsItem() {
  const queryClient = useQueryClient();
  return useMutation(deleteItem, {
    onError: (error) =>
      toast(
        error.message ?? 'Failed to delete news item, please try again later.',
        {
          type: 'error',
        }
      ),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries('news-feed');
      toast('News item deleted successfully', {
        type: 'success',
      });
    },
  });
}

async function fetchNewsFeed() {
  const response = await fetch('/api/news');
  const responseBody = await response.json();
  if (!response.ok) throw new ApiError(responseBody.message, response.status);
  return responseBody;
}

export default function useNewsFeed() {
  return useQuery('news-feed', fetchNewsFeed, {
    onError(error) {
      toast(error.message, { type: 'error' });
    },
  });
}
